import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useAppDispatch } from "../../store";
import {
  applyReferralCodeThunk,
  getUserInfoThunk,
} from "../../store/actions/auth.action";
import { message } from "antd";

const ReferralCodeSection = () => {
  const dispatch = useAppDispatch();

  const [expandReferralInput, setExpandReferralInput] = useState(false);
  const [referralCode, setReferralCode] = useState("");

  const onSubmit = async () => {
    try {
      await dispatch(
        applyReferralCodeThunk({
          referralCode: referralCode.toLocaleLowerCase(),
        })
      ).unwrap();
      message.success("Apply promotion code successfully");
      setReferralCode("");
      setExpandReferralInput(false);
      await dispatch(getUserInfoThunk());
    } catch (error: any) {
      console.error(error);
      message.error(error.message || "Failed to apply promotion code!");
    }
  };

  return (
    <Container>
      {!expandReferralInput ? (
        <ReferralLink>
          <a onClick={() => setExpandReferralInput(true)}>
            Add promotion code
          </a>
        </ReferralLink>
      ) : (
        <ReferralForm>
          <Input
            id="referral-code"
            type="text"
            placeholder="Enter promotion code"
            value={referralCode}
            onChange={(event) => setReferralCode(event.target.value)}
          />
          <ButtonGroup>
            <SecondaryButton onClick={onSubmit} disabled={!referralCode}>
              Submit
            </SecondaryButton>
            <CancelButton
              onClick={() => {
                setExpandReferralInput(false);
                setReferralCode("");
              }}
            >
              Cancel
            </CancelButton>
          </ButtonGroup>
        </ReferralForm>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const ReferralLink = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5px;

  a {
    color: #3a6df3;
    text-decoration: none;
    cursor: pointer;
    width: fit-content;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(58, 109, 243, 0.1);
      text-decoration: none;
    }
  }
`;

const ReferralForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 400px;
  padding: 16px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: white;
  font-size: 14px;
  box-sizing: border-box;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3a6df3;
    box-shadow: 0 0 0 2px rgba(58, 109, 243, 0.2);
    background-color: rgba(255, 255, 255, 0.08);
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active {
    transform: translateY(1px);
  }
`;

const CancelButton = styled(Button)`
  background-color: transparent;
  border: 1px solid rgba(239, 68, 68, 0.5);
  color: #ef4444;

  &:hover {
    background-color: rgba(239, 68, 68, 0.1);
    border-color: #ef4444;
  }
`;

const SecondaryButton = styled(Button)`
  background-color: #3a6df3;
  border: 1px solid #3a6df3;
  color: white;

  &:hover {
    background-color: #2d5ad9;
    border-color: #2d5ad9;
  }

  &:disabled {
    background-color: rgba(58, 109, 243, 0.5);
    border-color: rgba(58, 109, 243, 0.5);
  }
`;

export default ReferralCodeSection;
